/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from "react";
import { DATA_TABLE_GUTTER_CLASS } from "components/DataTable/gutter";
import InvetoriesList from "./InvetoriesList";
import inventoryManager from "services/Inventory/inventoryManager";
import {
  FaEdit,
  FaEye,
  FaMobileAlt,
  FaLaptop,
  FaTools,
  FaHistory,
  FaApple,
  FaAndroid,
  FaDesktop,
  FaMicrochip,
  FaMouse,
  FaKeyboard,
  FaHeadphones,
  FaPlug,
  FaUsb,
  FaCarBattery,
  FaTabletAlt,
} from "react-icons/fa";
import { MdOutlineSimCard } from "react-icons/md";
import { BsSmartwatch } from "react-icons/bs";
import Modal from "components/Modal";
import ViewProduct from "./ViewProduct";
import AddProduct from "./AddProduct";
import DeleteInventory from "./DeleteInventory";
import EditInventory from "./EditInventory";
// import Badge from "components/Badge";
import { useTranslation } from "react-i18next";
import { useAppContext } from "contexts";
import History from "./history";
import HeaderButtons from "components/Button/HeaderButtons";
import GenericModal from "components/Modal";
import InventoryRequestForm from "./InventoryRequestForm";
// Page-level toaster: it stays mounted after the request modal closes, which is
// what the modal's own toaster could not do (same pattern as InventoryRequestList)
import GenericToaster from "components/Toaster";
import InventoryRequestList from "./InventoryRequestList";
import Button from "components/Button";
import apiService from "services/apiService";
import { InputActionMeta } from "react-select";
import { sortByKey } from "util/sortOptions";
import { inventoryOptions } from "./inventoryValues";
import CommonListingFilter, {
  CommonFilterField,
  CommonFilterOption,
} from "components/CommonListingFilter/CommonListingFilter";
import { dateFormate } from "util/Util";
// import { TruncatedText } from "pages/AdminConfig/components/TruncatedText";

interface OptionProps {
  value: string;
  label: string;
}

export default function Invetories() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [Invetories, setInvetories] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [productData, setProductData] = useState();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [histroy, setHistroy] = useState(false);
  const [hData, sethData] = useState();
  const [isRequestingAsset, setIsRequestingAsset] = useState(false);
  const [activeTab, setActiveTab] = useState<"assets" | "requests" | "my-requests">("assets");
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [selectedInventory, setSelectedInventory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState<OptionProps | null>(null);
  const [selectedDeviceType, setSelectedDeviceType] = useState<OptionProps | null>(null);
  const [draftSelectedUser, setDraftSelectedUser] = useState<OptionProps | null>(null);
  const [draftSelectedDeviceType, setDraftSelectedDeviceType] = useState<OptionProps | null>(null);
  const [userOptions, setUserOptions] = useState<OptionProps[]>([]);
  const [userPage, setUserPage] = useState(0);
  const [userSearch, setUserSearch] = useState("");
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const USER_PAGE_SIZE = 10;

  const getAssetsFromPayload = (payload: any) => {
    if (Array.isArray(payload?.assets)) {
      return payload.assets;
    }
    if (Array.isArray(payload?.content)) {
      return payload.content;
    }
    return [];
  };

  const getUsersFromPayload = (payload: any) => {
    if (Array.isArray(payload)) {
      return payload;
    }

    if (Array.isArray(payload?.content)) {
      return payload.content;
    }

    return [];
  };
  const { t } = useTranslation();
  const { userRole } = useAppContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleView = (row: any) => {
    console.log("row", row);
    setProductData(row);
    setOpenModal(true);
  };

  //  Here added Function for Capitalize First Letter for Owner Grid

  const handleFirstLetter = (string: string) => {
    if (!string) {
      return false;
    } else {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  };
  const tableColumns = [
    {
      key: "assign",
      label: `${t("inventories.assign")}`,
      className: "text-gray-900 font-semibold",
      render: (row: any) => {
        const textValue = row?.length > 0 ? row : "unassigned";
        return (
          <span
            className="block truncate max-w-[80px] lg:max-w-[100px] xl:max-w-[120px]"
            title={textValue}
          >
            {textValue}
          </span>
        );
      },
    },
    {
      key: "owner",
      label: `${t("inventories.owner")}`,
      bold: true,
      render: (row: any) => {
        const val = handleFirstLetter(row);
        const textValue = typeof val === "string" ? val : "";
        return (
          <span
            className="block truncate max-w-[80px] lg:max-w-[100px] xl:max-w-[120px]"
            title={textValue}
          >
            {textValue}
          </span>
        );
      },
    },
    {
      key: "location",
      label: `${t("inventories.location")}`,
      render: (row: any) => {
        const textValue = String(row || "");

        const truncatedContent = (
          <span
            className="inline-block truncate max-w-[60px] lg:max-w-[80px] xl:max-w-[100px] align-middle"
            title={textValue}
          >
            {textValue}
          </span>
        );

        return truncatedContent;
        // if (row === "Bangalore") {
        //   return <Badge>{truncatedContent}</Badge>;
        // } else {
        //   return (
        //     <Badge className="bg-purple-100 text-purple-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-purple-900 dark:text-purple-300">
        //       {truncatedContent}
        //     </Badge>
        //   );
        // }
      },
    },
    {
      key: "model",
      label: `Model`,
      bold: true,
      render: (value: any) => {
        const textValue = String(value ?? "");
        return (
          <span
            className="block truncate max-w-[80px] lg:max-w-[100px] xl:max-w-[120px]"
            title={textValue}
          >
            {textValue}
          </span>
        );
      },
    },
    {
      key: "brand",
      label: `${t("inventories.brand")}`,
      bold: true,
      render: (value: any) => {
        const textValue = String(value ?? "");
        return (
          <span
            className="block truncate max-w-[60px] lg:max-w-[80px] xl:max-w-[100px]"
            title={textValue}
          >
            {textValue}
          </span>
        );
      },
    },
    {
      key: "assignDate",
      label: `${t("inventories.assignDate")}`,
      render: (value: any) => dateFormate(String(value)),
    },
    {
      key: "type",
      label: `${t("inventories.type")}`,
      render: (row: any) => {
        switch (row) {
          case "IPhone":
            return <FaApple title="IPhone" />;
          case "Android":
            return <FaAndroid title="Android" />;
          case "Mobile": // Keeping for backwards compatibility if needed
            return <FaMobileAlt title="Mobile" />;
          case "Laptop":
            return <FaLaptop title="Laptop" />;
          case "SIM":
            return <MdOutlineSimCard title="SIM" />;
          case "Monitor":
            return <FaDesktop title="Monitor" />;
          case "CPU":
            return <FaMicrochip title="CPU" />; // Alternatively: FaServer
          case "Mouse":
            return <FaMouse title="Mouse" />;
          case "KeyBoard":
            return <FaKeyboard title="Keyboard" />;
          case "Headphone":
            return <FaHeadphones title="Headphone" />;
          case "Charger":
            return <FaPlug title="Charger" />;
          case "USB":
            return <FaUsb title="USB" />;
          case "UPS":
            return <FaCarBattery title="UPS" />;
          case "Tablet":
            return <FaTabletAlt title="Tablet" />;
          case "Smart Watch":
          case "Smart_Watch":
            return <BsSmartwatch title="Smart Watch" />;
          default:
            return <FaTools title={row || "Tools"} />;
        }
      },
    },
    {
      key: "status",
      label: `${t("inventories.status")}`,
      render: (row: any) => {
        const updateStatus = row.length > 0 ? row : "Status Not Defined";
        const normalizedStatus = String(row || "").trim().toLowerCase();

        if (normalizedStatus === "working" || normalizedStatus === "running") {
          return (
            <span className="flex items-center text-sm font-medium text-gray-900 dark:text-white me-3">
              <span className="flex w-2.5 h-2.5 bg-teal-500 rounded-full me-1.5 flex-shrink-0"></span>
              {row}
            </span>
          );
        } else if (normalizedStatus === "not working") {
          return (
            <span className="flex items-center text-sm font-medium text-gray-900 dark:text-white me-3">
              <span className="flex w-2.5 h-2.5 bg-red-500 rounded-full me-1.5 flex-shrink-0"></span>
              {updateStatus}
            </span>
          );
        } else if (row.length > 0) {
          return (
            <span className="flex items-center text-sm font-medium text-gray-900 dark:text-white me-3">
              <span className="flex w-2.5 h-2.5  bg-yellow-300 rounded-full me-1.5 flex-shrink-0"></span>
              {row}
            </span>
          );
        } else {
          return (
            <span className="flex items-center text-sm font-medium text-gray-900 dark:text-white me-3">
              <span className="flex w-2.5 h-2.5  bg-yellow-300 rounded-full me-1.5 flex-shrink-0"></span>
              {row}
            </span>
          );
        }
      },
    },

    {
      key: "actions",
      label: `${t("inventories.actions")}`,
      excludeExport: true,
      actions: (row: any) => (
        <div className="flex flex-start">
          {(userRole === 2 || userRole === 3) && (
            <span
              className="btn-primary px-2 py-2 mr-2 rounded-lg"
              onClick={() => handleEdit(row)}
            >
              <FaEdit className="text-white" />
            </span>
          )}

          <span
            className="btn-primary px-2 py-2 mr-2 rounded-lg"
            onClick={() => handleView(row)}
          >
            <FaEye className="text-white" />
          </span>
          <span
            className="btn-primary px-2 py-2 mr-2 rounded-lg"
            onClick={() => {
              setHistroy(true);
              sethData(row);
            }}
          >
            <FaHistory className="text-white" />
          </span>
        </div>
      ),
    },
  ];

  const fetchUsers = async (nextPage: number, searchValue: string, append: boolean) => {
    if (loadingUsers) return;

    setLoadingUsers(true);
    try {
      const query = new URLSearchParams();
      query.set("page", String(nextPage));
      query.set("size", String(USER_PAGE_SIZE));
      if (searchValue.trim()) {
        query.set("search", searchValue.trim());
      }

      const res = await apiService.get(`api/users?${query.toString()}`);
      const payload = res.data;
      const users = getUsersFromPayload(payload);

      const options = users
        .filter((item: any) => item?.email)
        .map((item: any) => ({
          value: item.email,
          label: item.displayName || item.email,
        }));

      setUserOptions((prev) => {
        const merged = append ? [...prev, ...options] : options;
        const dedup = new Map<string, OptionProps>();
        merged.forEach((item) => {
          if (!dedup.has(item.value)) {
            dedup.set(item.value, item);
          }
        });
        return sortByKey(Array.from(dedup.values()), "label");
      });

      setUserPage(nextPage);
      if (typeof payload?.last === "boolean") {
        setHasMoreUsers(!payload.last);
      } else if (typeof payload?.totalPages === "number") {
        setHasMoreUsers(nextPage < payload.totalPages - 1);
      } else {
        setHasMoreUsers(options.length === USER_PAGE_SIZE);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadingUsers(false);
    }
  };

  // Role 1 (regular user) cannot filter by other users — skip the user list fetch entirely
  useEffect(() => {
    if (userRole === 1) {
      return;
    }
    const timer = window.setTimeout(() => {
      fetchUsers(0, userSearch, false);
    }, 350);

    return () => window.clearTimeout(timer);
  }, [userSearch, userRole]);

  useEffect(() => {
    if (activeTab !== "assets") return;

    setLoading(true);
    const queryParams = {
      page,
      size,
      username: searchTerm.trim() || undefined,
      userEmail: selectedUser?.value || undefined,
      type: selectedDeviceType?.value || undefined,
      asset_type: selectedInventory !== "All" ? selectedInventory : undefined,
    };

    inventoryManager
      .getInventoryData(queryParams)
      .then((res) => {
        const payload = res.data;
        const assets = getAssetsFromPayload(payload);

        const sortedData = assets.sort((a: any, b: any) => {
          if (!a.assign && !b.assign) return 0;
          if (!a.assign) return 1;
          if (!b.assign) return -1;
          return a.assign.toLowerCase().localeCompare(b.assign.toLowerCase());
        });

        const parsedTotalElements = Number((payload as any)?.totalElements);
        const apiTotalElements =
          Number.isFinite(parsedTotalElements)
            ? parsedTotalElements
            : sortedData.length;

        setInvetories(sortedData);
        setTotalElements(apiTotalElements);
      })
      .catch((error) => {
        console.error("Error fetching inventory list:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    refresh,
    activeTab,
    page,
    size,
    searchTerm,
    selectedUser?.value,
    selectedDeviceType?.value,
    selectedInventory,
  ]);
  const [addProduct, setAddPrdouct] = useState(false);
  const handleAddfunction = () => {
    setAddPrdouct(!addProduct);
  };
  const [deleteProduct, setDeletePrdouct] = useState(false);

  const [editProduct, setEditPrdouct] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleEdit = (row: any): void => {
    setProductData(row);
    setEditPrdouct(true);
  };
  const BreadCrumbList = [
    { name: "Inventory", link: "inventories" },
    { name: "list", link: "#" },
  ];

  const handleButtonClick = (value: string) => {
    setSelectedInventory(value);
    setPage(0);
  };

  const keepForFutureUse = {
    HeaderButtons,
    Button,
    BreadCrumbList,
    handleButtonClick,
  };
  keepForFutureUse;

  const handleUserSearch = (
    inputValue: string,
    meta: InputActionMeta
  ): string => {
    if (meta.action === "input-change") {
      setUserSearch(inputValue);
      return inputValue;
    }

    if (meta.action === "menu-close") {
      setUserSearch("");
      return "";
    }

    return inputValue;
  };

  const loadMoreUsers = () => {
    if (hasMoreUsers && !loadingUsers) {
      fetchUsers(userPage + 1, userSearch, true);
    }
  };

  const handleRequestClick = () => {
    setIsRequestingAsset(true)
  }
  const onCloseRequestForm = () => {
    setIsRequestingAsset(false);
  }

  // Holds the asset-request result so the toast survives the modal closing
  const [requestToastData, setRequestToastData] = useState<{
    message: string;
    severity: "info" | "error";
  } | null>(null);

  const isAdminOrManager = userRole === 2 || userRole === 3;

  // Role 1 (regular user) sees only the Device Type filter.
  // The User field is hidden because role-1 users cannot filter by other users,
  // and the user list API is not called for them.
  const inventoryFilterFields: CommonFilterField[] = [
    ...(userRole !== 1
      ? [
          {
            id: "inventory-user",
            type: "select" as const,
            label: "User",
            placeholder: "All Users",
            widthClass: "min-w-[220px]",
            queryParam: "userEmail",
            options: userOptions as CommonFilterOption[],
            value: draftSelectedUser as CommonFilterOption | null,
            isClearable: true,
            isSearchable: true,
            isLoading: loadingUsers,
            onInputChange: handleUserSearch,
            onMenuScrollToBottom: loadMoreUsers,
            noOptionsMessage: () =>
              loadingUsers ? "Loading users..." : "No users found",
            onChange: (option: CommonFilterOption | null) => {
              setDraftSelectedUser(option);
            },
          } as CommonFilterField,
        ]
      : []),
    {
      id: "inventory-device",
      type: "select",
      label: "Device Type",
      placeholder: "Device Type",
      widthClass: "min-w-[200px]",
      queryParam: "type",
      options: inventoryOptions as CommonFilterOption[],
      value: draftSelectedDeviceType as CommonFilterOption | null,
      isClearable: true,
      isSearchable: true,
      onChange: (option) => {
        setDraftSelectedDeviceType(option);
      },
    },
  ];

  const inventoryFilterControls = (
    <CommonListingFilter
      fields={inventoryFilterFields}
      panelTitle="Inventory Filter"
      disableApplyOnEmpty={true}
      onApply={() => {
        setSelectedUser(draftSelectedUser);
        setSelectedDeviceType(draftSelectedDeviceType);
        setPage(0);
      }}
      onClear={() => {
        setDraftSelectedUser(null);
        setDraftSelectedDeviceType(null);
      }}
      onReset={() => {
        setDraftSelectedUser(null);
        setDraftSelectedDeviceType(null);
        setSelectedUser(null);
        setSelectedDeviceType(null);
        setPage(0);
        return false;
      }}
    />
  );

  const inventoryExportParams = {
    model: searchTerm.trim() || undefined,
    userEmail: selectedUser?.value || undefined,
    type: selectedDeviceType?.value || undefined,
    asset_type: selectedInventory !== "All" ? selectedInventory : undefined,
  };

  const handleInventoryPageChange = useCallback((nextPage: number) => {
    setPage(nextPage - 1);
  }, []);

  const handleInventoryItemsPerPageChange = useCallback((nextSize: number) => {
    setSize(nextSize);
    setPage(0);
  }, []);

  const handleInventorySearchTermChange = useCallback((nextSearchTerm: string) => {
    setSearchTerm(nextSearchTerm);
    setPage(0);
  }, []);

  return (
    <>
      {/* <BreadCrumb BreadCrumbList={BreadCrumbList} /> */}

      {/* Tab Navigation */}
      <div className={`${DATA_TABLE_GUTTER_CLASS} !pb-0 !mb-0`}>
        <div className="flex gap-1 border-b border-slate-200 dark:border-slate-700">
          <button
            onClick={() => setActiveTab("assets")}
            className={`px-4 py-2 text-sm font-medium transition-colors ${activeTab === "assets"
              ? "border-b-2 border-primary text-primary"
              : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
              }`}
          >
            Asset List
          </button>
          {isAdminOrManager && (
            <button
              onClick={() => setActiveTab("requests")}
              className={`px-4 py-2 text-sm font-medium transition-colors ${activeTab === "requests"
                ? "border-b-2 border-primary text-primary"
                : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                }`}
            >
              Request List
            </button>
          )}

        </div>
      </div>


      {activeTab === "assets" && (
        userRole === 2 || userRole === 3 ? (
          <InvetoriesList
            data={Invetories}
            columns={tableColumns}
            onAdd={handleAddfunction}
            loading={loading}
            selectedInventory={selectedInventory}
            onRequestAsset={handleRequestClick}
            leftSideButtons={inventoryFilterControls}
            itemsPerPage={size}
            currentPage={page + 1}
            totalItems={totalElements}
            onPageChange={handleInventoryPageChange}
            onItemsPerPageChange={handleInventoryItemsPerPageChange}
            onSearchTermChange={handleInventorySearchTermChange}
            exportParams={inventoryExportParams}
          />
        ) : (
          <InvetoriesList
            data={Invetories}
            columns={tableColumns}
            loading={loading}
            selectedInventory={selectedInventory}
            onRequestAsset={handleRequestClick}
            leftSideButtons={inventoryFilterControls}
            itemsPerPage={size}
            currentPage={page + 1}
            totalItems={totalElements}
            onPageChange={handleInventoryPageChange}
            onItemsPerPageChange={handleInventoryItemsPerPageChange}
            onSearchTermChange={handleInventorySearchTermChange}
            exportParams={inventoryExportParams}
          />
        )
      )}

      {/* Request List Tab — admin/manager only */}
      {activeTab === "requests" && isAdminOrManager && (
        <InventoryRequestList />
      )}

      {/* My Requests Tab — all roles */}
      {activeTab === "my-requests" && (
        <InventoryRequestList showMyRequests />
      )}

      {openModal && (
        <Modal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          header="View Inventory"
        >
          {productData && <ViewProduct product={productData} />}
        </Modal>
      )}

      {addProduct && (
        <Modal
          isOpen={addProduct}
          onClose={() => setAddPrdouct(false)}
          header="Add Inventory"
          // customCss={{
          //   width: "900px !important",
          //   top: "0px",
          // }}
          customWidth="900px"
        >
          {addProduct && (
            <AddProduct
              onClose={() => setAddPrdouct(false)}
              setRefresh={setRefresh}
              refresh={refresh}
            />
          )}
        </Modal>
      )}
      {deleteProduct && (
        <Modal
          isOpen={deleteProduct}
          onClose={() => setDeletePrdouct(false)}
          header="Delete Inventory"
        >
          {deleteProduct && (
            <DeleteInventory
              onClose={() => setDeletePrdouct(false)}
              data={productData}
            />
          )}
        </Modal>
      )}
      {editProduct && (
        <Modal
          isOpen={editProduct}
          onClose={() => setEditPrdouct(false)}
          header="Edit Inventory"
          // customWidth="sm:[calc(90vw-50px)]"
          customWidth="900px"
        >
          {editProduct && (
            <EditInventory
              onClose={() => setEditPrdouct(false)}
              data={productData}
              setRefresh={setRefresh}
              refresh={refresh}
            />
          )}
        </Modal>
      )}
      {
        isRequestingAsset && <GenericModal
          isOpen={isRequestingAsset}
          onClose={onCloseRequestForm}
          header="Request inventory"
        >
          {/* onSuccess hands the toast to this page, which is still mounted
              after the modal closes — without it the toast was lost */}
          <InventoryRequestForm
            onClose={onCloseRequestForm}
            onSuccess={(toastPayload) => {
              onCloseRequestForm();
              setRequestToastData(toastPayload);
            }}
          ></InventoryRequestForm>
        </GenericModal>
      }
      {histroy && (
        <Modal
          isOpen={histroy}
          onClose={() => setHistroy(false)}
          header="Inventory History"
          customCss={{
            // position: "absolute",
            padding: "px",
            // width: "900px !important",
            border: "1px solid #94a3b8", // Slate-400: Visible in both light and dark modes
            outline: "none" // Removes the default blue focus ring
          }}
          customWidth="sm:max-w-4xl"
        >
          {histroy && <History onClose={() => setHistroy(false)} row={hData} />}
        </Modal>
      )}

      {/* Asset-request result, rendered at page level so it is visible once the
          request modal has closed */}
      {requestToastData && (
        <GenericToaster
          open={true}
          message={requestToastData.message}
          severity={requestToastData.severity}
          onClose={() => setRequestToastData(null)}
        />
      )}
    </>
  );
}
